import React, { memo } from 'react'

import logoPlusFriend from '../../../assets/logoPlusFriend.png'
import { useStoreContext } from '../../../contexts/StoreContext'
import { useHomeContent } from '../../../hooks/useHomeContent'

import './headerClub.scss'

const HeaderClub = () => {
  const { activatePlusFriendBadge } = useStoreContext()
  const { logo } = useHomeContent()

  return (
    <header className="club-container-client">
      {activatePlusFriendBadge ? (
        <img src={logoPlusFriend} alt="Logo +amigo" />
      ) : (
        <>
          <p className="club-subtitle">Clube</p>
          <img src={logo?.image} alt={logo?.alt} />
        </>
      )}
    </header>
  )
}

export default memo(HeaderClub)
